import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../contexts/LanguageContext";
import { ArrowUpRight } from "lucide-react";

const PROD_IMG_1 =
  "https://images.pexels.com/photos/5056853/pexels-photo-5056853.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const PROD_IMG_2 =
  "https://images.unsplash.com/photo-1709293287084-544575bb1398?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxzdW5mbG93ZXIlMjBvaWwlMjBwb3VyaW5nfGVufDB8fHx8MTc3NzEzMjEyN3ww&ixlib=rb-4.1.0&q=85";
const PROD_IMG_3 =
  "https://images.unsplash.com/photo-1532634766-c2761df5daba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtYW51ZmFjdHVyaW5nJTIwZmFjaWxpdHklMjBmYWN0b3J5JTIwY2xlYW58ZW58MHx8fHwxNzc3MTMyMTI3fDA&ixlib=rb-4.1.0&q=85";
const PROD_IMG_4 =
  "https://www.saipol.com/uploads/2020/08/PM_CETIOM_240605_512.jpg";

const IMGS = [PROD_IMG_1, PROD_IMG_2, PROD_IMG_3, PROD_IMG_4];

const Products = () => {
  const { t } = useLang();
  const list = t.products.list;

  return (
    <section
      id="products"
      data-testid="products-section"
      className="relative bg-[#FDFBF7] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-16 reveal">
          <div className="flex items-center gap-3 mb-6">
            <span className="divider-line" />
            <span className="overline text-[#DE9E36]">{t.products.overline}</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl text-[#1A201C] font-bold leading-[1.1] tracking-tight">
            {t.products.title}
          </h2>
          <p className="mt-6 text-base sm:text-lg text-[#4E5750] leading-relaxed">
            {t.products.subtitle}
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6 auto-rows-[minmax(380px,auto)]">
          {list.map((p, i) => {
            const span =
              i === 0
                ? "md:col-span-7 md:row-span-2"
                : i === 1
                ? "md:col-span-5"
                : i === 2
                ? "md:col-span-5"
                : "md:col-span-7";
            return (
              <Link
                to={`/product/${p.slug}`}
                key={p.slug}
                data-testid={`product-card-${i}`}
                className={`reveal group relative overflow-hidden border border-[#E5E0D8] bg-white transition-transform duration-500 hover:-translate-y-2 ${span}`}
                style={{ transformStyle: "preserve-3d" }}
              >
                <div className="absolute inset-0">
                  <img
                    src={IMGS[i]}
                    alt={p.name}
                    className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
                </div>

                <div className="relative h-full min-h-[380px] flex flex-col justify-end p-7 md:p-9 text-white">
                  <span className="absolute top-7 left-7 px-3 py-1 text-[10px] tracking-[0.22em] uppercase border border-white/40 backdrop-blur-sm bg-white/10 rounded-full">
                    {p.tag}
                  </span>
                  <span className="absolute top-7 right-7 w-10 h-10 rounded-full border border-white/30 flex items-center justify-center group-hover:bg-[#DE9E36] group-hover:border-[#DE9E36] transition-all">
                    <ArrowUpRight
                      size={16}
                      className="transition-transform group-hover:rotate-45"
                    />
                  </span>

                  <h3 className="text-2xl md:text-3xl font-bold leading-tight tracking-tight">
                    {p.name}
                  </h3>
                  <p className="mt-3 text-sm text-white/80 max-w-md leading-relaxed">
                    {p.desc}
                  </p>
                  <div className="mt-5 pt-5 border-t border-white/15 flex items-center justify-between gap-3">
                    <span className="text-xs text-[#F1C779] font-mono">{p.spec}</span>
                    <span className="overline text-white/70 group-hover:text-[#DE9E36] transition-colors">
                      {t.products.explore} →
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Products;
